/* eslint-disable react/jsx-no-undef */
import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import BackButton from "../../components/button/BackButton";
import TopBanner from '../../components/layout/TopBanner';
import TopLogo from '../../components/layout/TopLogo';
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import calendar from "../../assets/images/icon/calendar.svg";
import { InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useLiff } from 'react-liff';
import background from '../../assets/images/bg-info.png';
import upload from "../../assets/images/icon/upload.svg";
import add from "../../assets/images/icon/add.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { FormControl, FormHelperText } from "@mui/material";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import img from "../../assets/images/icon/img.svg";
import bin from "../../assets/images/icon/bin.svg";
import dayjs from "dayjs";
import { useDispatch, useSelector } from 'react-redux';
import { setLuckyDraw } from "../../features/LuckyDrawSlice";
import { InsertBill } from "../../services/LuckyDraw";
import { SearchDdlBuyFrom } from "../../services/Dropdown";
import { Controller, useForm } from "react-hook-form";
import { SearchMemberProfile } from "../../services/Member";
import ErrorPopup from "../../components/popup/ErrorPopup";
import CustomPopup from "../../components/popup/CustomPopup";
import logo from '../../assets/images/logo-lucky.png';
import backgroundLucky from '../../assets/images/bg-lucky.jpg';

export default function LuckyDrawFrom() {

  // lineId
  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  const today = new Date();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const store = useSelector((state) => state.luckyDraw)

  const [openErrorPopup, setOpenErrorPopup] = React.useState(false);
  const [openErrorImagePopup, setOpenErrorImagePopup] = React.useState(false);
  const [popupTitle, setPopupTitle] = React.useState('รูปต้องมีขนาดไม่เกิน 5 MB')
  const [popupDesc, setPopupDesc] = React.useState('กรุณาลองใหม่อีกครั้ง')
  const [isSubmit, setIsSubmit] = React.useState(false)

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    getValues,
    setError,
    clearErrors
  } = useForm({
    defaultValues: {
      birthdate: null,
      buyFrom: '',
      billDate: null
    },
  });

  const [imageName, setImageName] = useState(null);
  const [image, setImage] = useState(null);
  const [ddlBuyFrom, setDdlBuyFrom] = useState([{ id: 2, name: "Ladaza" }]);

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setLuckyDraw(tmpObj));
  }

  const initialInputValues = {
    productGroup: "",
    productId: "",
    product: "",
    amount: null,
    point: 0,
    openSlide: true,
  };

  const initialErrorInput = {
    productGroup: false,
    product: false,
    amount: false,
  };

  const productOptionDefault = store['productList'];
  const [productOption, setProductOption] = useState(store['productList']);
  // const productOptionDefault = [
  //   { buyFrom: 2, group: "Haier เครื่องปรับอากาศอินเวอร์เตอร์ UV Cool Premium ขนาด 13300 BTU", codeList: [{ id: 1, point: 96, code: "HSU-13VSWA03T (ติดตั้งฟรี)" }] },
  //   { buyFrom: 2, group: "Haier ตู้เย็นไซด์บายไซด์ อินเวอร์เตอร์ ความจุ 15.6 คิว", codeList: [{ id: 2, point: 42, code: "HRF-SBS501GB" }] },
  //   { buyFrom: 2, group: "Haier เครื่องปรับอากาศอินเวอร์เตอร์ UV Cool Premium ขนาด 18000 BTU", codeList: [{ id: 3, point: 38, code: "HSU-18VSWA03T (ติดตั้งฟรี)" }] },
  //   { buyFrom: 2, group: "Haier เครื่องซักผ้าฝาบนอัตโนมัติ อินเวอร์เตอร์ ความจุ 18 kg", codeList: [{ id: 4, point: 30, code: "HWM180-B278S6" }] },
  //   { buyFrom: 2, group: "Haier เครื่องซักผ้าฝาหน้าอัตโนมัติ อินเวอร์เตอร์ ความจุ 8 kg", codeList: [{ id: 5, point: 27, code: "HW80-BP12929A" }] },
  //   { buyFrom: 2, group: "Haier ตู้แช่แข็งฝาทึบ 2 ระบบ ความจุ 7.1 คิว", codeList: [{ id: 6, point: 21, code: "HCF-200HM2" }] },
  //   { buyFrom: 2, group: "Haier ตู้เย็นไซด์บายไซด์ อินเวอร์เตอร์ ความจุ 19 คิว", codeList: [{ id: 7, point: 18, code: "RSB59CRFD1OL" }] },
  //   { buyFrom: 2, group: "Haier เครื่องปรับอากาศติดผนัง Fixed Speed ขนาด 12000 BTU", codeList: [{ id: 8, point: 9, code: "EH-12QEM/EH-12QEMC (ไม่รวมติดตั้ง)" }] },
  //   { buyFrom: 2, group: "Haier ตู้แช่ ตู้แช่แข็งฝากระจกระบบ Low Frost ขนาด 142 ลิตร /5.0 คิว", codeList: [{ id: 9, point: 7, code: "HCF-LF208 (สีขาว)" }] },
  //   { buyFrom: 2, group: "Haier ตู้เย็น 2 ประตู Fixed Speed ความจุ 8.7 คิว", codeList: [{ id: 10, point: 7, code: "HRF-THM26NS ONL" }] },
  //   { buyFrom: 2, group: "Haier ตู้เย็น 2 ประตู Fixed Speed ความจุ 6.9 คิว", codeList: [{ id: 11, point: 6, code: "HRF-THM22NS ONL" }] },
  //   { buyFrom: 2, group: "Haier ตู้แช่แข็งฝาทึบ 2 ระบบ ความจุ 5.1 คิว", codeList: [{ id: 12, point: 6, code: "HCF-145HM2" }] },
  //   { buyFrom: 2, group: "Haier ตู้แช่แข็งฝาทึบ 2 ระบบ ความจุ 3.5 คิว", codeList: [{ id: 13, point: 5, code: "HCF-100HM2" }] },
  //   { buyFrom: 2, group: "Haier ตู้เย็น 1 ประตู Muse series ขนาด 177 ลิตร/6.3 คิว", codeList: [{ id: 14, point: 5, code: "HR-CEQ18X (สีเงิน สีม่วง สีฟ้า สีช็อคโกแลต)" }] },
  //   { buyFrom: 2, group: "Haier เครื่องซักผ้าฝาบน อัตโนมัติ ขนาด 7 กิโลกรัม", codeList: [{ id: 15, point: 5, code: "HWM70-1708T" }] },
  //   { buyFrom: 2, group: "Haier เครื่องซักผ้า 2 ถัง กึ่งอัตโนมัติ ความจุ 11 kg", codeList: [{ id: 16, point: 4, code: "HTW110-1217" }] },
  //   { buyFrom: 2, group: "Haier เครื่องซักผ้า 2 ถัง กึ่งอัตโนมัติ ความจุ 9 kg", codeList: [{ id: 17, point: 3, code: "HTW90-1217" }] },
  //   { buyFrom: 2, group: "Haier ตู้เย็นมินิบาร์ ขนาด 1.7 คิว", codeList: [{ id: 18, point: 3, code: "HR-50" }] },
  //   { buyFrom: 2, group: "Haier เตาอบไมโครเวฟ ความจุ 20 ลิตร (700 W)", codeList: [{ id: 19, point: 2, code: "HMW-MC20BH" }] },
  //   { buyFrom: 2, group: "Haier เตาอบไมโครเวฟ ขนาด 20 ลิตร", codeList: [{ id: 20, point: 2, code: "HMW-M2001W" }] }
  // ];
  // const [productOption, setProductOption] = useState(store['productList']);
  const [codeOption, setCodeOption] = useState([]);
  const [disableProduct, setDisableProduct] = useState(true);


  const [userInputs, setUserInputs] = useState([{ ...initialInputValues }]);
  const [errorInputs, setErrorInputs] = useState([{ ...initialErrorInput }]);

  const addProductForm = () => {
    setUserInputs([...userInputs, { ...initialInputValues }]);
    setCodeOption([...codeOption, []]);
    setErrorInputs([...errorInputs, { ...initialErrorInput }]);
  };

  const removeProductForm = (index) => {
    const userInputList = [...userInputs];
    const errorInputList = [...errorInputs];
    const codeOptionList = [...codeOption];

    userInputList.splice(index, 1);
    errorInputList.splice(index, 1);
    codeOptionList.splice(index, 1);

    setUserInputs(userInputList);
    setErrorInputs(errorInputList);
    setCodeOption(codeOptionList)
  };

  React.useEffect(() => {
    getSearchMemberProfile();
    getSearchDdlBuyFrom();
  }, []);

  async function getSearchMemberProfile() {
    return await SearchMemberProfile({ lineId })
      .then(async (response) => {
        if (+response.data.resultCode !== 20000) {
          navigate("/register");
        } else {
          const result = response.data.body
          // setMemberInfo(response.data.body)
          setValue('firstName', result.firstName)
          setValue('lastName', result.lastName)
          setValue('email', result.email)
          setValue('mobileNumber', result.mobileNumber)
          setValue('birthdate', result.birthdate)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getSearchDdlBuyFrom() {
    return await SearchDdlBuyFrom( {
      params: {
        campaignId: store['campaignId']
      }
    })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          setDdlBuyFrom(response.data.body)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function isValidEmail(email) {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
  }

  const handleChangeEmail = event => {
    if (event.target.value && !isValidEmail(event.target.value)) {
      setError('email', {
        type: "email",
        message: "อีเมลไม่ถูกต้อง"
      });
    } else {
      fnSetData('email', event.target.value)
      clearErrors('email');
    }
  };

  const handleUserInputChange = (
    event,
    index,
    fieldName = null,
    newValue = null
  ) => {
    let { name, value } = event?.target ?? { name: fieldName, value: newValue };
    const updatedUserInputs = [...userInputs];
    console.log(name)
    if (name === 'product') {
      updatedUserInputs[index]['productId'] = value.id;
      updatedUserInputs[index]['point'] = value.point;
      updatedUserInputs[index]['product'] = value;
    } if (name === 'productGroup') {
      updatedUserInputs[index][name] = value;
      updatedUserInputs[index]['productId'] = null;
      updatedUserInputs[index]['point'] = 0;
      updatedUserInputs[index]['product'] = '';
    } else {
      updatedUserInputs[index][name] = value;
    }
    setUserInputs(updatedUserInputs);
    if (name === 'productGroup') {
      const txt = productOption.find(
        (item) => item.group == value
      );
      const updatedCodeList = [...codeOption];
      if (updatedCodeList.length > 0) {
        updatedCodeList[index] = txt.codeList;
      } else {
        updatedCodeList.push(txt.codeList)
      }
      setCodeOption(updatedCodeList)
    }
  };

  function fnOnChangeBuyFrom(event) {
    if (event.target.value) {
      setValue('buyFrom', event.target.value)
      const Ans = productOptionDefault.filter((item) => item.buyFrom === event.target.value);
      setProductOption(Ans)
      setDisableProduct(false)
      console.log(Ans)
    }
  }

  function validateInputField(field, index) {
    const updatedErrorInputs = [...errorInputs];
    updatedErrorInputs[index][field] = userInputs[index][field] ? false : true;
    setErrorInputs(updatedErrorInputs);
  }

  function validateInputs() {
    let valid = true;
    let updatedErrors = [];
    for (var index = 0; index < userInputs.length; index++) {
      let updatedError = {
        productGroup: userInputs[index].productGroup !== "" ? false : true,
        product: userInputs[index].product !== "" ? false : true,
        amount: userInputs[index].amount !== null ? (userInputs[index].amount  <= 0 ? true : false)  : true,
      };
      updatedErrors.push(updatedError);
      valid = !Object.values(updatedError).some((field) => field);
    }
    console.log(updatedErrors)
    setErrorInputs(updatedErrors);
    return valid;
  }

  const handleImage = (event) => {
    const file = event.target.files[0];
    setImageName(event.target.files[0].name)
    const reader = new FileReader();
    if (event.target.files[0].size > 5242880) {
      setPopupTitle('รูปต้องมีขนาดไม่เกิน 5 MB')
      setPopupDesc('กรุณาลองใหม่อีกครั้ง')
      setOpenErrorImagePopup(true)
    } else {
      reader.onloadend = () => {
        setValue('picture', event.target.files[0].name)
        setImage(reader.result.substring(
          reader.result.indexOf(",") + 1
        ))
      };
      reader.readAsDataURL(file);
    }
  };

  function removeImage() {
    setImageName(null)
    setImage(null)
  };


  function onSubmit(data) {
    if (validateInputs()) {
      setIsSubmit(true)
      postInsertBill(data)
    } else {
      setIsSubmit(false)
    }
  };



  async function postInsertBill(data) {
    let productList = []
    let total = 0
    let point = 0
    for (let index = 0; index < userInputs.length; index++) {
      const element = userInputs[index];
      console.log(element)
      productList.push({
        id: element.productId,
        amount: element.amount,
        point: element.point,
      })
      total += +element.amount
      point += (+element.amount * element.point)
    }



    fnSetData('billDate', dayjs(getValues('billDate')).format('DD/MM/YYYY'))
    fnSetData('total', total)
    fnSetData('point', point)

    const payload =
    {
      memberId: store['memberId'],
      campaignId: store['campaignId'],
      buyFrom: data.buyFrom,
      shopName: data.shopName,
      billNo: data.billNo,
      billDate: dayjs(data.billDate).add(7, 'hours'),
      productList: productList,
      picture: image,
      contactName: data.firstName + ' ' + data.lastName,
      contactTel: data.mobileNumber,
      contactEmail: data.email,
      contactBirthdate: dayjs(data.birthdate).add(7, 'hours'),
      totalPoint: point
    }
    console.log(payload)
    return await InsertBill({ data: payload })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          navigate('/lucky-draw-success')
        } else if (+response.data.resultCode === 40301) {
          setIsSubmit(false)
          setPopupTitle('ขออภัย')
          setPopupDesc('หมายเลขคำสั่งซื้อนี้ถูกลงทะเบียนไปแล้ว')
          setOpenErrorImagePopup(true)
        } else {
          setOpenErrorPopup(true)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }




  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <ErrorPopup
          open={openErrorPopup}
          actionFunction={() => {
            setOpenErrorPopup(false)
          }}
        />

        <CustomPopup
          title={popupTitle}
          desc={popupDesc}
          cancelText="ปิด"
          cancelFunction={() => {
            setOpenErrorImagePopup(false);
          }}
          open={openErrorImagePopup}
        />
        <TopLogo />
        <div id="shop"
          style={{
            background: `url(${store['bgPicture']}) no-repeat center center fixed`,
            minHeight: "calc(100vh - 60px)",
            backgroundSize: "cover"
          }}
          className="px-[20px]">
          <TopBanner type="luckyDraw2" img={store['logoPicture']} />
          {/* <TopBanner type="luckyDraw2" img={store['bannerPicture']} /> */}
          {/* <div style={{
          backgroundImage: `url(${background})`,
          minHeight: "calc(100vh - 60px)",
          padding: "20px",
          marginTop: "-4px"
        }}> */}

          <div className="bg-white px-3" style={{ borderRadius: "8px" }}>
            <div style={{ padding: "0 10px" }}>
              <div className="flex gap-[10px] justify-start">
                <div className="primary-color title-size">ข้อมูลผู้ติดต่อ</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size"> Contact Information</p>
                  <div className="blue-line" ></div>
                </div>
              </div>


              <div className="grid grid-cols-2 gap-2">
                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtFirstName">ชื่อ </InputLabel>
                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtLastName">นามสกุล </InputLabel>
              </div>
              <div className="grid grid-cols-2 gap-5">
                <TextField
                  id="txtFirstName"
                  required
                  fullWidth
                  error={!!errors?.firstName}
                  helperText={errors?.firstName?.message}
                  {...register("firstName", { required: "กรุณากรอกชื่อ" })}
                  placeholder="ชื่อของคุณ"
                />

                <TextField
                  id="txtLastName"
                  required
                  fullWidth
                  error={!!errors?.lastName}
                  helperText={errors?.lastName?.message}
                  {...register("lastName", { required: "กรุณากรอกนามสกุล" })}
                  placeholder="นามสกุลของคุณ"
                />
              </div>

              <div className={errors?.firstName || errors?.lastName ? '' : ' mt-2'}>
                <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">เบอร์โทรศัพท์ </InputLabel>
                <TextField
                  id="txtMobileNumber"
                  fullWidth
                  required
                  type="number"
                  error={!!errors?.mobileNumber}
                  helperText={errors?.mobileNumber?.message}
                  placeholder="เบอร์โทรศัพท์ของคุณ"
                  {...register("mobileNumber", { required: "กรุณากรอกเบอร์โทรศัพท์" })}
                />
              </div>

              <div className={errors?.mobileNumber ? '' : ' mt-2'}>
                <InputLabel className="text-header1 text-left text-required" htmlFor="txtEmail">อีเมล </InputLabel>
                <TextField
                  id="txtEmail"
                  fullWidth
                  error={!!errors?.email}
                  helperText={errors?.email?.message}
                  placeholder="อีเมลของคุณ"
                  {...register("email", {
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "อีเมลไม่ถูกต้อง"
                    }
                    ,
                    required: "กรุณากรอกอีเมล"
                  })
                  }
                  onChange={handleChangeEmail}
                />
              </div>

              <div className={errors?.email ? 'relative' : 'relative mt-2'}>
                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtEmail">วัน/เดือน/ปี ที่เกิด </InputLabel>
                <Controller
                  name="birthdate"
                  control={control}
                  rules={{
                    required: "กรุณาเลือกวัน/เดือน/ปีที่เกิด",
                  }}
                  render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDatePicker
                        {...field}
                        className="w-full"
                        inputFormat="DD/MM/YYYY"
                        maxDate={today}
                        name="birthdate"
                        onChange={(date) => field.onChange(date)}
                        selected={field.value}
                        renderInput={(params) => (
                          <TextField
                            name="birthdate"
                            {...params}
                            error={!!errors?.birthdate}
                            helperText={errors?.birthdate?.message}
                            placeholder="วัน / เดือน / ปี"
                          />
                        )}
                      />
                      <img
                        className={
                          `absolute right-[10px] bottom-[15px] w-[18px] pointer-events-none ` +
                          (!!errors?.birthdate
                            ? "bottom-[42px]"
                            : null)
                        }
                        src={calendar}
                        alt=""
                      />
                    </LocalizationProvider>
                  )}
                />
              </div>


              <div className="flex gap-[10px] justify-start">
                <div className="primary-color title-size">ข้อมูลใบเสร็จ</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size"> Bill Information</p>
                  <div className="blue-line" ></div>
                </div>
              </div>

              <div>
                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtEmail">ช่องทางการสั่งซื้อ </InputLabel>
                <Controller
                  name="buyFrom"
                  control={control}
                  rules={{
                    required: "กรุณาเลือกช่องทางการสั่งซื้อ",
                  }}
                  render={({ field }) => (
                    <FormControl fullWidth error={!!errors?.buyFrom}>
                      <Select
                        {...field}
                        onChange={(event) => { fnOnChangeBuyFrom(event) }}
                        displayEmpty
                        IconComponent={KeyboardArrowDownIcon}
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem disabled value="">
                          <span style={{ color: "#B7B7B7" }}>เลือกช่องทางการสั่งซื้อ</span>
                        </MenuItem>
                        {ddlBuyFrom.length > 0 &&
                          ddlBuyFrom.map((item, i) => (
                            <MenuItem value={item.id} key={i}>
                              {item.name}
                            </MenuItem>
                          ))}
                      </Select>
                      <FormHelperText>กรุณาเลือกชื่อยี่ห้อสินค้า</FormHelperText>
                    </FormControl>
                  )}
                />
              </div>

              <div className={errors?.buyFrom ? '' : ' mt-2'}>
                <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">ชื่อร้านค้า </InputLabel>
                <TextField
                  id="txtMobileNumber"
                  fullWidth
                  required
                  error={!!errors?.shopName}
                  helperText={errors?.shopName?.message}
                  placeholder="กรอกชื่อร้านค้า"
                  {...register("shopName", { required: "กรุณากรอกชื่อร้านค้า" })}
                />
              </div>

              <div className={errors?.shopName ? 'relative' : 'relative mt-2'}>
                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtEmail">วันที่ออกใบเสร็จ </InputLabel>
                <Controller
                  name="billDate"
                  control={control}
                  rules={{
                    required: "กรุณากรอกวันที่ออกใบเสร็จ",
                  }}
                  render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDatePicker
                        {...field}
                        className="w-full"
                        inputFormat="DD/MM/YYYY"
                        maxDate={today}
                        name="billDate"
                        onChange={(date) => field.onChange(date)}
                        selected={field.value}
                        renderInput={(params) => (
                          <TextField
                            name="billDate"
                            {...params}
                            error={!!errors?.billDate}
                            helperText={errors?.billDate?.message}
                            placeholder="วันที่ออกใบเสร็จของคุณ"
                          />
                        )}
                      />
                      <img
                        className={
                          `absolute right-[10px] bottom-[15px] w-[18px] pointer-events-none ` +
                          (!!errors?.billDate
                            ? "bottom-[42px]"
                            : null)
                        }
                        src={calendar}
                        alt=""
                      />
                    </LocalizationProvider>
                  )}
                />
              </div>

              <div className={errors?.billDate ? '' : ' mt-2'}>
                <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">หมายเลขคำสั่งซื้อ </InputLabel>
                <TextField
                  id="txtMobileNumber"
                  fullWidth
                  required
                  error={!!errors?.billNo}
                  helperText={errors?.billNo?.message}
                  placeholder="กรอกหมายเลขคำสั่งซื้อ"
                  {...register("billNo", { required: "กรุณากรอกหมายเลขคำสั่งซื้อ" })}
                />
              </div>

              {image ? (
                <div className={errors?.billNo ? '' : 'mt-[20px]'}>
                  <div className="px-[20px] mb-[10px] w-full h-[48px] relative flex justify-center items-center gap-[5px] rounded-full border-[1px] border-lightBlue">
                    <img className="w-[17px]" src={img} alt="" />
                    <p className="short-text text-lightblue text-[24px]"> {imageName}</p>
                    <div
                      onClick={() => {
                        removeImage();
                      }}
                      className="cursor-pointer flex gap-[5px] items-center right-[20px] top-[0px] py-[1px]"
                    >
                      <FontAwesomeIcon
                        icon={faXmark}
                        className="w-[12px] text-red"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className={errors?.billNo ? '' : 'mt-[20px]'}>
                  <FormControl fullWidth error={!!errors?.picture}>
                    <div className="w-full h-[48px] relative flex justify-center items-center gap-[5px] rounded-full border-[1px] border-gray">
                      <img className="w-[18px]" src={upload} alt="" />
                      <p className="text-gray text-[24px]"> อัปโหลดใบเสร็จ</p>
                      <input
                        required
                        className="opacity-0 absolute left-0 top-0 bottom-0 right-0"
                        name="urlPicture"
                        type="file"
                        accept=".jpg, .jpeg, .png"
                        error={!!errors?.picture}
                        {...register("picture", { required: "กรุณาอัปโหลดรูปภาพใบเสร็จ" })}
                        onChange={(event) => handleImage(event)}
                      />
                    </div>
                    <div className="mb-[-10px]" style={{ fontSize: '0.8571428571428571rem', color: '#8F8F8F' }}>* รูปต้องมีขนาดไม่เกิน 5 MB</div>
                    <FormHelperText>กรุณาอัปโหลดรูปภาพใบเสร็จ</FormHelperText>
                  </FormControl>
                </div>
              )}



              <div className="flex gap-[10px] justify-start mt-[10px]">
                <div className="primary-color title-size">ข้อมูลสินค้า</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size"> Product Information</p>
                  <div className="blue-line" ></div>
                </div>
              </div>

              <div>
                {userInputs.map((userInput, index) => (
                  <div key={index}>
                    <div
                      className={`transition-all duration-200 slide${userInput.openSlide ? " down" : " up"
                        }`}
                    >
                      <div style={{ float: "right" }}>
                      </div>

                      <div className="pb-[10px]">

                        <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtEmail">เลือกสินค้า </InputLabel>
                        <FormControl fullWidth error={errorInputs[index].productGroup}>
                          <Select
                            disabled={disableProduct}
                            displayEmpty
                            IconComponent={KeyboardArrowDownIcon}
                            fullWidth
                            defaultValue=""
                            name="productGroup"
                            value={
                              userInput.productGroup || ""
                            }
                            onChange={(event) => {
                              handleUserInputChange(event, index)
                              validateInputField('productGroup', index)
                            }}
                          >
                            <MenuItem disabled value="">
                              <span style={{ color: "#B7B7B7" }}>เลือกสินค้าของคุณ</span>
                            </MenuItem>
                            {productOption &&
                              productOption.map((item, i) => (
                                <MenuItem value={item.group} key={i}>
                                  {item.group}
                                </MenuItem>
                              ))}
                          </Select>
                          <FormHelperText>ชื่อสินค้าไม่ถูกต้อง</FormHelperText>
                        </FormControl>

                        <InputLabel required={true} className={errorInputs[index].productGroup ? "text-header1 text-required text-left" : "text-header1 text-required text-left mt-3"} htmlFor="txtEmail">รหัสสินค้า </InputLabel>
                        <FormControl fullWidth error={errorInputs[index].product}>
                          <Select
                            disabled={!userInput.productGroup}
                            displayEmpty
                            IconComponent={KeyboardArrowDownIcon}
                            fullWidth
                            defaultValue=""
                            name="product"
                            value={
                              userInput.product || ""
                            }
                            onChange={(event) => {
                              handleUserInputChange(event, index)
                              validateInputField('product', index)
                            }}
                          >
                            <MenuItem disabled value="">
                              <span style={{ color: "#B7B7B7" }}>เลือกรหัสสินค้าของคุณ</span>
                            </MenuItem>
                            {codeOption[index] &&
                              codeOption[index].map((item, i) => (
                                <MenuItem value={item} key={i}>
                                  {item.code}
                                </MenuItem>
                              ))}
                          </Select>
                          <FormHelperText>รหัสสินค้าไม่ถูกต้อง</FormHelperText>
                        </FormControl>

                        <div className={errorInputs[index].product ? "h-input mb-[30px]" : "h-input mt-3 mb-[30px]"}>
                          <InputLabel className="text-header1 text-required text-left" htmlFor="txtEmail">จำนวนสินค้า </InputLabel>
                          <TextField
                            id="txtEmail"
                            name="amount"
                            inputProps={{ min: 4, max: 10 }}
                            fullWidth
                            type="number"
                            error={errorInputs[index].amount}
                            placeholder="กรอกจำนวนสินค้า"
                            helperText="กรุณากรอกจำนวนสินค้า"
                            value={userInput.amount || ""}
                            onChange={(event) => {
                              handleUserInputChange(event, index)
                              validateInputField('amount', index)
                            }
                            }
                          />
                        </div>

                        {userInputs.length > 1 && <button
                          onClick={() => {
                            removeProductForm(index);
                          }}
                          className="mt-[20px] w-fit flex gap-[5px] items-center justify-center py-[1px] px-[20px] rounded-[5px] border-[1px] border-blue"
                        >
                          <img className="w-[10px]" src={bin} alt="" />
                          <p className="text-blue text-[20px]">ลบสินค้า</p>
                        </button>}

                        {userInputs.length > 1 && <div className="gray-line my-3 " ></div>}

                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <BackButton className="w-full mt-3"
                onClick={addProductForm}>
                <img className="w-[18px]" src={add} alt="" />
                <p>เพิ่มสินค้า</p>
              </BackButton>

              <br></br>
              <br></br>
              <br></br>
            </div>
          </div>

        </div>
        <div className="bg-white h-[100px] pt-[25px]">
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => navigate(-1)}>
              ย้อนกลับ
            </SecondaryButton>

            <PrimaryButton variant="contained" className="w-[40%]" type="submit" disabled={isSubmit} onClick={() => validateInputs()}>
              ยืนยัน
            </PrimaryButton>

          </Stack>
        </div>
      </form >
    </>
  );
}
